<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-form
        @submit.prevent="patientSave()"
        ref="form"
        v-model="valid"
        lazy-validation
    >
      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <span v-if="patient_data.patient_id">
            <v-card-title style="background-color: #FC6336; color: white">
              <b>PATIENT ID: <v-icon></v-icon>{{ patient_data.patient_id }}</b>
            </v-card-title>
            </span>
            <v-card-title>
              Please Enter Mobile Number
            </v-card-title>
            <v-col>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                      label="Mobile Phone Number"
                      hide-details="auto"
                      v-model="patient_data.patient_phone"
                      v-on:keyup="getPatient(patient_data.patient_phone)"
                      :loading="loadingstatus"
                      outline
                      :rules="rules.required"
                      required
                      outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                      :items="patientSource"
                      v-model="patient_data.patient_source"
                      item-text="ps_name"
                      item-value="id"
                      required
                      label="Referral Type"
                      outlined
                      dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                      :items="patientSourceSubCat"
                      item-text="ps_name"
                      item-value="id"
                      v-model="patient_data.patient_source_cat"
                      required
                      label="Referral Name"
                      outlined
                      dense
                  ></v-select>
                  <v-text-field
                      label="Card No"
                      v-model="patient_data.family_eye_card"
                      v-show="setDisable()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      label="Patient Name"
                      :rules="rules.nameRules"
                      v-model="patient_data.patient_name"
                      v-on:change="getPatientGender(patient_data.patient_name)"
                      required
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <template>
                    <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                        :disabled="ageFieldDisabled === false"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="patient_data.patient_dob"
                            label="Date of Birth (yy-mm-dd)"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :rules="rules.required"
                            required
                            outlined
                            dense
                            :disabled="ageFieldDisabled === false"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          ref="picker"
                          v-model="patient_data.patient_dob"
                          :max="new Date().toISOString().substr(0, 10)"
                          min="1930-01-01"
                          v-on:change="save"
                      ></v-date-picker>
                    </v-menu>
                  </template>
                </v-col>
                <v-col cols="4" class="d-flex align-center">
                  <v-checkbox
                      label="সঠিক তারিখ জানা নেই"
                      v-model="patient_data.dob_not_known_check"
                      :true-value="1"
                      :false-value="0"
                      hide-details
                      class="mt-0 pt-0"
                      v-on:change="checkAgeFieldAbleDisable"
                  ></v-checkbox>
                </v-col>
                <v-col cols="2">
                  <v-text-field
                      label="Age"
                      v-model="patient_data.patient_age"
                      hide-details="auto"
                      v-on:change="getAge(patient_data.patient_age)"
                      outlined
                      dense
                      type="number"
                      :disabled="ageFieldDisabled === true"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-radio-group
                      row
                      v-model="patient_data.patient_gender"
                      :rules="rules.required"
                      required
                  >
                    <template v-slot:label>
                      <div>Select <strong>Gender</strong></div>
                    </template>
                    <v-radio label="Male" value="Male"></v-radio>
                    <v-radio label="Female" value="Female"></v-radio>
                    <v-radio label="Other" value="Other"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="6">
                  <v-autocomplete
                      v-model="patient_data.patient_occupation"
                      label="Occupation"
                      outlined
                      dense
                      :items="occupation_items"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6" >
                  <v-autocomplete
                      :items="referralDoctors"
                      v-model="patient_data.referral_doctor_id"
                      item-text="dr_name"
                      item-value="id"
                      required
                      label="Referral Doctor"
                      outlined
                      dense
                  ></v-autocomplete>
                </v-col><v-col cols="2" >
                <v-btn depressed color="warning" type="button"  @click="clearReferralDoctor()">
                  <v-icon>
                    mdi-minus-circle
                  </v-icon>
                </v-btn>
              </v-col>
                <v-col cols="4">
                  <v-select
                      :items="bloodGroup"
                      v-model="patient_data.patient_blood_group"
                      required
                      label="Patient Blood Group"
                      outlined
                      dense
                  ></v-select>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="patient_data.father_name"
                      label="Father Name"
                      hide-details="auto"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="patient_data.mother_name"
                      label="Mother Name"
                      hide-details="auto"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="patient_data.patient_email"
                      label="Email Address"
                      hide-details="auto"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="patient_data.patient_address"
                      label="Address"
                      hide-details="auto"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="patient_data.national_id"
                      label="National ID Number"
                      hide-details="auto"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                      v-model="patient_data.birth_cert_no"
                      label="Birth Certificate Number"
                      hide-details="auto"
                      outlined
                      dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-row style="margin-left: 10px; margin-right: 10px" align="center" justify="space-around">
              <div v-if="spinnerButtons">
                <v-progress-circular :width="12" size="61" color="green" indeterminate style="margin-top: 5px; margin-bottom: 10px"></v-progress-circular>
              </div>
              <div v-else>
                <v-btn style="margin-top: 5px; margin-bottom: 10px" v-if="patient_data.p_id"
                       depressed
                       color="primary"
                       :disabled="buttonUpdate"
                       type="submit"
                >
                  Save Changes
                </v-btn>
                <v-btn style="margin-top: 5px; margin-bottom: 10px" v-else
                       depressed
                       color="primary"
                       :disabled="buttonSubmit"
                       type="submit"
                >
                  Save
                </v-btn>
              </div>
            </v-row>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card :loading="loadingstatus">
            <template slot="progress">
              <v-progress-linear height="10" indeterminate></v-progress-linear>
            </template>
            <v-card-title>
              Existing patients
              <v-spacer></v-spacer>
              <v-chip v-if="patientData.length" small color="warning" outlined>
                {{ patientData.length }} found — click edit to update, do not create again
              </v-chip>
            </v-card-title>
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">ID</th>
                  <th class="text-left">Name</th>
                  <th class="text-left">Phone</th>
                  <th class="text-left">DOB</th>
                  <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in patientData" :key="item.id">
                  <td>{{ item.patient_id }}</td>
                  <td>{{ item.patient_name }}</td>
                  <td>{{ item.patient_phone }}</td>
                  <td>{{ item.patient_dob }}</td>
                  <td>
                    <v-icon color="primary" v-on:click="getPatientData(item)">
                      mdi-pencil
                    </v-icon>
                    <v-icon color="primary" v-on:click="viewItem(item)">
                      mdi-eye
                    </v-icon>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<style scoped></style>
<script>
import atshq from "../../../js/setup";

export default {
  data() {
    return {
      spinnerButtons: true,
      valid: true,
      disabled: 0,
      patient_edit_data: this.$route.params.id,
      patientSource: [],
      patientSourceSubCat: [],
      referralDoctors: [],
      buttonSubmit: false,
      buttonUpdate: true,
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      returnUrl: "",
      search: "",
      loadingstatus: true,
      loading: false,
      menu: false,
      ageFieldDisabled: true,
      column: null,
      rules: {
        required: [(value) => !!value || "Required."],
        nameRules: [
          (v) => !!v || "Patient Name is required",
          (v) =>
              (v && v.length <= 100) || "Name must be less than 100 characters",
        ],
      },

      occupation_items: [
        "",
        "Doctor",
        "Engineer",
        "Student",
        "Govt. Service",
        "Service",
        "Business",
        "Home Maker",
        "Unemployment",
        "Retired Person",
      ],
      patient_data: {
        p_id: null,
        patient_id: null,
        patient_name: null,
        patient_age: null,
        patient_dob: null,
        dob_not_known_check: 0,
        patient_phone: null,
        patient_source: 17,
        patient_source_cat: 18,
        patient_gender: null,
        patient_email: null,
        patient_address: null,
        patient_blood_group: null,
        family_eye_card: null,
        patient_occupation: null,
        national_id: null,
        birth_cert_no: null,
        referral_doctor_id: null,
        father_name: null,
        mother_name: null,
        user_id: localStorage.getItem("userId"),
      },
      malePostfix: [
        "hossain",
        "rahman",
        "bhuiya",
        "islam",
        "hasan",
        "gazi",
        "mia",
        "maih",
      ],
      femalePostfix: ["khanam", "khatun", "bala", "nessa", "sultana", "akter"],
      bloodGroup: ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "patient_id",
        },
        {text: "Name", value: "patient_name"},
        {text: "Phone", value: "patient_phone"},
        {text: "DOB", value: "patient_dob"},
        {text: "Age", value: "patient_age"},
        {text: "Gender", value: "patient_sex"},
        {text: "Reg. Date", value: "admission_date"},
      ],
      desserts: [],
      patientData: [],

      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Patients",
          disabled: true,
          href: "patients",
        },
      ],
    };
  },
  // Fetches posts when the component is created.
  created() {
    if (this.patient_edit_data) {
      this.editPatient(this.patient_edit_data);
    }
    // atshq.defaults.headers.common["Authorization"] =
    //   "Bearer " + localStorage.getItem("token");
    this.initialize();
    this.setDisable();
    this.checkAgeFieldAbleDisable();
  },
  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
  },
  methods: {
    checkAgeFieldAbleDisable() {
      this.ageFieldDisabled = this.patient_data.dob_not_known_check != 1;
    },
    initialize() {
      this.spinnerButtons = true;
      atshq
          .get("patients/patients/create")
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            this.desserts = response.data.data;
            this.patientSource = response.data.data.patient_source;
            this.patientSourceSubCat = response.data.data.patient_all;
            this.referralDoctors = response.data.data.referral_doctors;
            this.spinnerButtons = false;
          })
          .catch((e) => {
            // this.errors.push(e);
            this.spinnerButtons = false;
            this.$noty.error("Oops, something went wrong!");
            this.$noty.error(" " + e);
          });
    },
    editPatient(patient_id) {
      atshq
          .get("patients/patient-profile/" + patient_id)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.loadingstatus = false;
            const patient = response.data.data.patient;
            this.getPatientData(patient);
            if (patient && patient.patient_phone) {
              this.getPatient(patient.patient_phone);
            }
            if ((response.data.data.invoice).length > 0) {
              this.disabled = 1;
            }
            this.spinnerButtons = false;
          })
          .catch((e) => {
            // this.errors.push(e);
            this.$noty.error("Oops, " + e);
            this.spinnerButtons = false;
          });
    },
    getPatient(phoneNo) {
      this.loadingstatus = true
      this.patientData = [];
      if (phoneNo && String(phoneNo).length >= 6) {
        atshq
            .get("patients/patient-search-by-phone/" + phoneNo)
            .then((response) => {
              // JSON responses are automatically parsed.
              this.loadingstatus = false;
              this.patientData = response.data.data;
            })
            .catch((e) => {
              // this.errors.push(e);
              this.loadingstatus = false;
              this.$noty.error("Oops, something went wrong!");
              this.$noty.error(" " + e);
            });
      } else {
        this.loadingstatus = false;
      }
    },
    getPatientGender(patientName) {
      let postfix = patientName.split(" ").pop();

      if (this.malePostfix.includes(postfix.toLowerCase())) {
        this.patient_data.patient_gender = "Male";
      }
      if (this.femalePostfix.includes(postfix.toLowerCase())) {
        this.patient_data.patient_gender = "Female";
      }
    },
    getPatientData(patientData) {
      this.patient_data.p_id = patientData.id;
      this.patient_data.patient_id = patientData.patient_id;
      this.patient_data.patient_name = patientData.patient_name;
      this.patient_data.patient_dob = patientData.patient_dob;
      this.patient_data.dob_not_known_check = patientData.dob_not_known_check == 1 ? 1 : 0;
      this.patient_data.patient_age = patientData.patient_age;
      this.patient_data.patient_phone = patientData.patient_phone;
      this.patient_data.patient_blood_group = patientData.patient_blood_group;
      this.patient_data.patient_source = patientData.org_referral;
      this.patient_data.patient_source_cat = patientData.patient_referral_id;
      this.patient_data.patient_gender = patientData.patient_sex;
      this.patient_data.patient_email = patientData.patient_email;
      this.patient_data.patient_address = patientData.patient_address;
      this.patient_data.family_eye_card = patientData.family_eye_card;
      this.patient_data.patient_occupation = patientData.patient_occupation;
      this.patient_data.national_id = patientData.national_id;
      this.patient_data.birth_cert_no = patientData.birth_cert_no;
      this.patient_data.referral_doctor_id = patientData.referral_doctor_id;
      this.patient_data.father_name = patientData.father_name;
      this.patient_data.mother_name = patientData.mother_name;
      this.buttonSubmit = true;
      this.buttonUpdate = false;
      this.checkAgeFieldAbleDisable();
    },
    save(date) {
      let today = new Date();
      let birthDate = new Date(date);
      let age = today.getFullYear() - birthDate.getFullYear();
      let m = today.getMonth() - birthDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      this.patient_data.patient_age = age;
      this.$refs.menu.save(date);
    },
    getAge(a) {
      let age = parseInt(a);
      if (age > 99) {
        this.patient_data.patient_age = 99;
      }
      age = new Date(new Date().setFullYear(new Date().getFullYear() - age));
      var months = age.getMonth() + 1;
      age = age.getFullYear() + "-" + months + "-" + age.getDate();

      this.patient_data.patient_dob = age;
    },
    patientSave() {
      if (this.$refs.form.validate()) {
        // Prevent creating duplicate when same name + phone already exists in list
        if (!this.patient_data.p_id && this.patientData && this.patientData.length) {
          const phone = String(this.patient_data.patient_phone || '').slice(-11);
          const name = String(this.patient_data.patient_name || '').trim().toLowerCase();
          const existing = this.patientData.find((item) => {
            return String(item.patient_phone || '').slice(-11) === phone
                && String(item.patient_name || '').trim().toLowerCase() === name;
          });
          if (existing) {
            this.$noty.error('Sorry! Patient name and phone number already exists. Loading existing patient for edit.');
            this.getPatientData(existing);
            return;
          }
          if (!confirm('This phone number already has ' + this.patientData.length + ' patient(s). Are you sure you want to create a NEW patient? Click Cancel and use Edit on the right if this patient already exists.')) {
            return;
          }
        }

        this.spinnerButtons = true;
        let submitUrl = this.patient_data.p_id
            ? "patients/patients/" + this.patient_data.p_id
            : "patients/patients";
        if (this.patient_data.p_id) {
          atshq
              .put(submitUrl, {
                patientdata: this.patient_data,
              })
              .then((response) => {
                this.spinnerButtons = false;
                // JSON responses are automatically parsed.
                this.loadingstatus = false;
                this.$noty.success(response.data.messages);
                this.viewItem(response.data.data);
              })
              .catch((e) => {
                this.spinnerButtons = false;
                const msg = (e.response && e.response.data && (e.response.data.messages || e.response.data.message))
                    || 'Something went wrong';
                this.$noty.error(msg);
                if (e.response && e.response.status === 409 && e.response.data && e.response.data.data) {
                  this.getPatientData(e.response.data.data);
                }
              });
        } else {
          this.spinnerButtons = true;
          atshq
              .post(submitUrl, {
                patientdata: this.patient_data,
              })
              .then((response) => {
                this.spinnerButtons = false;
                // JSON responses are automatically parsed.
                this.loadingstatus = false;
                this.$noty.success(response.data.messages);
                this.viewItem(response.data.data);
              })
              .catch((e) => {
                this.spinnerButtons = false;
                const msg = (e.response && e.response.data && (e.response.data.messages || e.response.data.message))
                    || 'Something went wrong';
                this.$noty.error(msg);
                if (e.response && e.response.status === 409 && e.response.data && e.response.data.data) {
                  this.getPatientData(e.response.data.data);
                }
              });
        }
      } else {
        console.log("error");
      }
    },
    viewItem(item) {
      window.location.href = "/patient-details/" + item.patient_id;
    },
    setDisable() {
      if (this.patient_data.patient_source_cat == 21) {
        return true;
      }
      return false;
    },
    clearReferralDoctor() {
      this.patient_data.referral_doctor_id = null

    }
  },
};
</script>